app.directive('diagnoses', ['$stateParams', 'objectHelper', 'icdModel', 'userModel', 'applicationModel', 'diagnosisModel',
            '$mdDialog', '$timeout',
    function($stateParams, objectHelper, icdModel, userModel, applicationModel, diagnosisModel, $mdDialog, $timeout) {
        var definition = {
            restrict: 'E',
            replace: true,
            require: '^form',
            scope: {
                required: '=',
                visitCard: '=',
                patient: '=',
                visit: '=',
                template: '=',
                extras: '='
            },
            templateUrl: 'edm/application/directive/diagnoses/template/diagnoses.html',
            link: function($scope, element, attr, formCtrl) {
                $scope.form = formCtrl;
                $scope.favouriteIcd10List = [];
                $scope.diagnosisHistoryList = [];
                $scope.doctorId = userModel.getCurrentContextDoctorId();
                $scope.allowedTypes = ['diagnosis'];
                $scope.showPreviousIcons = (userModel && userModel.currentUser && userModel.currentUser.userType === 'DOCTOR');
                $scope.newDiagnosis = null;
                $scope.data = {
                    mainDiagnosisId: null,
                    hidden: null
                };
                $scope.isPreview = ($scope.template && $scope.template.user.id != userModel.currentUser.id);

                if(_.isUndefined(attr.extras)) {
                    $scope.extras = true;
                }

                $scope.$watch('visitCard', function(newVal) {
                    if(newVal && !$scope.data.mainDiagnosisId) {
                        $scope.data.mainDiagnosisId = function() {
                            var element = $scope.visitCard.diagnosisList.filter(function(d) { return d.mainAffliction });
                            return (element.length) ? element[0].id : null;
                        }();
                    }
                });

                $scope.removeDiagnosis = function (diagnosis) {
                    if(!$scope.template) {
                        if($scope.visit.visitStatus === Enum.VISIT_STATUS.COMPLETED) {
                            if(diagnosis.id) {
                                var label = diagnosis.icd10.description;
                                var configPopup = {
                                    templateUrl: 'edm/application/view/app/patient/popup/stateOfHealth/popup-delete-confirmation.html',
                                    controller: 'popupDeleteWithReasonController',
                                    controllerAs: 'deleteConfirmCtrl',
                                    skipHide: true,
                                    locals: {
                                        labels: label,
                                        item: diagnosis,
                                        userModel: userModel,
                                        $mdDialog: $mdDialog,
                                        message: 'T.MODULE.PATIENT.TAKEN_DRUG_DELETE_CONFIRMATION'
                                    }
                                };

                                $mdDialog.show(configPopup).then(function(data) {
                                    $scope.visitCard.diagnosisList.forEach(function(d, idx) {
                                        if(d.id === data.id) {
                                            $scope.visitCard.diagnosisList[idx] = angular.copy(data);
                                        }
                                    });
                                    updateMainDiagnosis();
                                });
                            } else {
                                _.remove($scope.visitCard.diagnosisList, function(element) {
                                    return element === diagnosis;
                                });
                            }
                        } else if($scope.visit.visitStatus === Enum.VISIT_STATUS.IN_PROGRESS) {
                            _.remove($scope.visitCard.diagnosisList, function(element) {
                                return element === diagnosis;
                            });
                            diagnosisModel.delete(diagnosis.id).then(function() {
                                updateMainDiagnosis();
                            })
                        }
                    } else {
                        _.remove($scope.template.diagnosisList, function(element) {
                            return element === diagnosis;
                        });
                    }
                };

                if($scope.extras) {
                    $scope.toggleFavourite = function(icd10) {
                        if(!$scope.isICD10Favourite(icd10)) {
                            icdModel.addFavouriteIcd10($scope.doctorId, icd10).then(onAddFavouriteICD10Success);
                        } else {
                            icdModel.deleteFavouriteIcd10($scope.doctorId, icd10).then(onDeleteFavouriteICD10Success);
                        }
                    };

                    $scope.isICD10Favourite = function(icd10) {
                        return $scope.favouriteIcd10List.some(function(favouriteICD10) {
                            return favouriteICD10.icd10.id === icd10.id;
                        })
                    };
                }


                $scope.addICD10ToDiagnosis = function(icd10) {
                    var newDiagnosis = new DiagnosisVO();
                    newDiagnosis.icd10 = icd10;
                    newDiagnosis.mainAffliction = $scope.getNotDeletedDiagnosis().length === 0;
                    if(!$scope.template) {
                        newDiagnosis.patient = new PatientVO();
                        newDiagnosis.patient.id = $scope.patient.id;
                        newDiagnosis.visitCard = new VisitCardVO($scope.visitCard.id);
                        $scope.visitCard.diagnosisList.push(newDiagnosis);
                        if(isVisitInProgress()) {
                            diagnosisModel.save(newDiagnosis).then(function (diagnosis) {
                                newDiagnosis.id = diagnosis.id;

                                if(newDiagnosis.mainAffliction) {
                                    diagnosisModel.setAsMainDiagnosis(newDiagnosis.id).then(function() {
                                        $scope.data.mainDiagnosisId = newDiagnosis.id;
                                    })
                                }
                            });
                        } else {
                            getDiagnosisList()[0].mainAffliction = true;
                        }
                    } else {
                        $scope.template.diagnosisList.push(newDiagnosis);
                    }
                };

                $scope.getNotDeletedDiagnosis = function () {
                    var diagnosisList = getDiagnosisList();
                    return diagnosisList.filter(function (diagnosis) {
                        return !diagnosis.deleted;
                    });
                };

                $scope.$watch('newDiagnosis', function(newVal, oldVal) {
                    if(!_.isUndefined(newVal) && newVal != null) {
                        $scope.addICD10ToDiagnosis(newVal);
                        $scope.newDiagnosis = undefined;
                    }
                });
                
                $scope.updateDiagnosis = function(diagnosis) {
                    if(!$scope.template && isVisitInProgress()) {
                        diagnosisModel.update(diagnosis)
                    }
                };

                $scope.setMainDiagnosis = function (mainDiagonsis) {
                    getDiagnosisList().forEach(function (diagnosis) {
                        diagnosis.mainAffliction = (diagnosis === mainDiagonsis);
                    });
                    if(!$scope.template && $scope.visit.visitStatus === Enum.VISIT_STATUS.IN_PROGRESS) {
                        diagnosisModel.setAsMainDiagnosis(mainDiagonsis.id);
                    }
                };

                if($scope.extras && userModel.currentUser.userType === 'DOCTOR') {
                    icdModel.getFavouriteIcd10List($scope.doctorId).then(onGetFavouriteICD10);
                    icdModel.getPatientDiagnosisHistory($scope.doctorId, $stateParams.patientId).then(onGetPatientDiagnosisHistory);
                }

                function onGetFavouriteICD10(data) {
                    $scope.favouriteIcd10List = data;
                }

                function onGetPatientDiagnosisHistory(data) {
                    $scope.diagnosisHistoryList = data.chronic.concat(data.nonChronic);
                }

                function onAddFavouriteICD10Success () {
                    icdModel.getFavouriteIcd10List($scope.doctorId).then(onGetFavouriteICD10);
                }

                function onDeleteFavouriteICD10Success () {
                    icdModel.getFavouriteIcd10List($scope.doctorId).then(onGetFavouriteICD10);
                }

                $scope.updateMainDiagnosis = function() {
                    var diagnosisList = $scope.getNotDeletedDiagnosis();

                    if(diagnosisList.length === 1) {
                        if(isVisitInProgress()) {
                            diagnosisModel.setAsMainDiagnosis(diagnosisList[0].id).then(function() {
                                $scope.data.mainDiagnosisId = diagnosisList[0].id;
                            });
                        } else {
                            diagnosisList[0].mainAffliction = true;
                            var deletedList = getDiagnosisList().filter(function(d) { return d.deleted });
                            diagnosisList = diagnosisList.concat(deletedList);
                            $scope.visitCard.diagnosisList = angular.copy(diagnosisList);
                        }
                    }
                    if(diagnosisList.length >= 1) {
                        var selectedId = parseInt($scope.data.mainDiagnosisId);
                        var ids = diagnosisList.map(function(d) { return d.id; });
                        if(ids.indexOf(selectedId) != -1) {
                            diagnosisList.forEach(function (element) {
                                element.mainAffliction = (element.id === selectedId);
                                if(element.mainAffliction && isVisitInProgress()) {
                                    diagnosisModel.setAsMainDiagnosis(element.id).then(function() {
                                        $scope.data.mainDiagnosisId = selectedId;
                                    })
                                }
                            });
                        }
                    }
                };

                function updateMainDiagnosis() {
                    var hasMainAffliction = false;
                    var diagnosisList = $scope.getNotDeletedDiagnosis();
                    diagnosisList.forEach(function (element) {
                        if(element.mainAffliction && !element.deleted) {
                            hasMainAffliction = true;
                        }
                    });
                    if(!hasMainAffliction && diagnosisList.length > 0) {
                        diagnosisList[0].mainAffliction = true;
                        updateDiagnosis(diagnosisList[0]);
                    }
                }

                function updateDiagnosis(diagnosis) {
                    if(!$scope.template && isVisitInProgress()) {
                        diagnosisModel.update(diagnosis)
                    }
                }

                function isVisitInProgress() {
                    return $scope.visit.visitStatus === Enum.VISIT_STATUS.IN_PROGRESS;
                }

                function getDiagnosisList() {
                    if($scope.template) {
                        return $scope.template.diagnosisList;
                    } else {
                        return $scope.visitCard.diagnosisList;
                    }
                }
            }
        };

        return definition;
    }
]);